import { UsersRepository } from '@User/Data/Repository/UsersRepository'
import { CreateUserPayload } from '@User/Data/DataSource/API/Entity/User'
import { DBUser } from '../Model/User'

export interface CreateUser {
    execute(user: CreateUserPayload): Promise<DBUser>
    getSource(): string
}

export class CreateUserUseCase implements CreateUser {
    constructor(private repository: UsersRepository) {}

    async execute(user: CreateUserPayload): Promise<DBUser> {
        return this.repository.create(user)
    }

    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}